import { lazy } from 'react';

import { RouteObject } from '@/types/router';

import { LazyLoad } from '../utils/lazy-load';

export default [
  {
    path: '/agency',
    children: [
      {
        index: true,
        element: LazyLoad(lazy(() => import('@/pages/agency/home'))),
      },
      {
        path: 'create',
        children: [
          {
            index: true,
            element: LazyLoad(lazy(() => import('@/pages/agency/create'))),
          },
          {
            path: 'submit',
            element: LazyLoad(lazy(() => import('@/pages/agency/create/submit'))),
          },
        ],
      },
      {
        path: 'invite',
        element: LazyLoad(lazy(() => import('@/pages/agency/invite'))),
      },
      {
        path: 'information',
        element: LazyLoad(lazy(() => import('@/pages/agency/information'))),
      },
      {
        path: 'wonderful-moment',
        element: LazyLoad(lazy(() => import('@/pages/agency/wonderful-moment'))),
      },
      {
        path: 'income',
        element: LazyLoad(lazy(() => import('@/pages/agency/income'))),
      },
      {
        path: 'member',
        element: LazyLoad(lazy(() => import('@/pages/agency/member'))),
      },
      {
        path: 'apply',
        children: [
          {
            path: 'member',
            element: LazyLoad(lazy(() => import('@/pages/agency/approve'))),
          },
        ],
      },
      {
        path: 'actions',
        children: [
          {
            index: true,
            element: LazyLoad(lazy(() => import('@/pages/agency/actions'))),
          },
        ],
      },
      {
        path: 'introducer',
        element: LazyLoad(lazy(() => import('@/pages/agency/introducer'))),
      },
      {
        path: 'search',
        element: LazyLoad(lazy(() => import('@/pages/agency/search'))),
      },
    ],
  },
] as RouteObject[];
